import React from 'react';

function RandomBloodGlucoseForm() {
  return (
    <div>
      <h2>RandomBloodGlucoseForm</h2>
    </div>
  );
}

export default RandomBloodGlucoseForm;
